module.exports = __webpack_public_path__ + "static/media/SIA Plus Playbook.921a6f4d.pdf";